import { ReactNode, MouseEvent } from 'react';
import classNames from 'classnames';

interface NotificationPanelFilterOptionWrapProps {
  children: ReactNode;
  textSize?: 'sm' | '[13px]';
  disabled?: boolean;
  inactive?: boolean;
  onClick?: (e: MouseEvent) => void;
}
export function NotificationPanelFilterOptionWrap(props: NotificationPanelFilterOptionWrapProps) {
  const { children, textSize = 'sm', disabled, inactive, onClick } = props;
  return (
    <div
      onClick={onClick}
      className={classNames(
        'text-' + textSize,
        disabled ? 'text-neutral-400' : 'text-neutral-800',
        'flex items-center h-8 px-3 transition-colors duration-200',
        inactive ? 'cursor-default' : 'cursor-pointer hover:bg-neutral-100'
      )}
    >
      {children}
    </div>
  );
}
